import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { FlexColumn, FlexRow, SvgIcon, useMatchMedia } from '@make-software/cspr-design';
import { HOME_PATH, SIGN_IN_PATH } from 'app/route/paths';
import { DesktopNavigationMenu, MobileNavigationMenu } from './navigation-menu';
import MenuIcon from 'assets/icons/ic-menu.svg';
import CloseSvgIcon from 'assets/icons/ic-close.svg';
import { AUTH_TOKEN } from 'app/constants';
import { decodeJWT } from 'app/components/utils/utils';
import { AssetsAliases } from 'app/assets';

const StyledHeader = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    height: '72px',
    width: '100%',
    backgroundColor: theme.styleguideColors.contentOnFill
  })
);

const HeaderContent = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    padding: '27px 44px'
  })
);

const HamburgerIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    color: theme.styleguideColors.fillPrimaryRed
  })
);

const CloseIcon = styled(SvgIcon)(({ theme }) =>
  theme.withMedia({
    path: {
      stroke: theme.styleguideColors.fillPrimaryRed
    }
  })
);

const Logo = () => (
  <FlexRow>
    <Link to={HOME_PATH}>
      <SvgIcon src={AssetsAliases.LogoOriginal} width={181} height={32} />
    </Link>
  </FlexRow>
);

const HamburgerButton = ({
  menuVisible,
  ...props
}: {
  menuVisible: boolean;
  onClick: () => void;
}) => {
  return menuVisible ? (
    <CloseIcon src={CloseSvgIcon} size={16} {...props} />
  ) : (
    <HamburgerIcon src={MenuIcon} size={16} {...props} />
  );
};

export const PageHeader = () => {
  const navigate = useNavigate();
  const [menuVisible, setMenuVisible] = useState(false);
  const [email, setEmail] = useState<string>('');
  useEffect(() => {
    const token = localStorage.getItem(AUTH_TOKEN);
    if (token) {
      const decodedJwt = decodeJWT(token);
      const parsedJwt = decodedJwt ? JSON.parse(decodeJWT(token)).email : '';
      setEmail(parsedJwt);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem(AUTH_TOKEN);
    navigate(SIGN_IN_PATH);
  };

  const onMobile = (
    <>
      <FlexRow justify={'space-between'} align={'center'}>
        <Logo />
        <HamburgerButton
          menuVisible={menuVisible}
          onClick={() => {
            setMenuVisible((visible) => !visible);
          }}
        />
      </FlexRow>
      {menuVisible && (
        <MobileNavigationMenu
          email={email}
          setMenuVisible={setMenuVisible}
          handleLogout={handleLogout}
        />
      )}
    </>
  );

  const onAbove = (
    <FlexRow justify={'flex-end'} align={'center'}>
      <DesktopNavigationMenu email={email} handleLogout={handleLogout} />
    </FlexRow>
  );

  const responsiveHeader = useMatchMedia(
    [onMobile, onMobile, onAbove, onAbove],
    [menuVisible, email]
  );
  return (
    <StyledHeader justify={'center'}>
      <HeaderContent>{responsiveHeader}</HeaderContent>
    </StyledHeader>
  );
};
